import {appAPI} from "../../../api";

export type BackupType = "hourly" | "daily" | "weekly";

/** Бэкап — префикс `backups/<type>/<stamp>/` с дампом БД и архивом uploads. */
export interface IBackupItem {
    key: string;
    type: BackupType;
    created_at: string;
    /** Размеры в байтах. */
    size_db: number;
    size_files: number;
}

export interface IBackupList {
    /** false — S3 не настроен, бэкапы выключены. */
    enabled: boolean;
    /** Имя базы — его вводят для подтверждения отката. */
    database: string;
    items: IBackupItem[];
}

const backupPath = `/backup`;

export const backupAPI = {
    getAll: async (): Promise<IBackupList> => {
        const res = await appAPI.get(backupPath);
        return res.data;
    },
    run: async (): Promise<{ created: string }> => {
        const res = await appAPI.post(`${backupPath}/run`);
        return res.data;
    },
    restore: async (key: string, confirm: string): Promise<{ restored: string }> => {
        const res = await appAPI.post(`${backupPath}/restore`, {key, confirm});
        return res.data;
    },
    remove: async (key: string): Promise<{ deleted: string }> => {
        const res = await appAPI.delete(backupPath, {params: {key}});
        return res.data;
    },
    getDownloadUrl: async (key: string, which: "db" | "files"): Promise<{ url: string }> => {
        const res = await appAPI.get(`${backupPath}/download`, {
            params: {key, which},
        });
        return res.data;
    },
};
